import urls from "../../../../../../global/constants/UrlConstants";
import { getCallParams, makeCall } from "../../../../../../utils/service";

export async function addStage(body: any) {
    try {
      const callParams = await getCallParams("POST", body);
      const response = await makeCall(urls.ADDSTAGE, callParams);
      return response;
    } catch (error) {
      throw error;
    }
  }


  export async function getStage() {
  
    try {
      const callParams = await getCallParams("GET");
      const response = await makeCall(urls.GETSTAGEDATA, callParams);
      console.log(response,"reminderResponseData")
      return response;
    } catch (error) {
      throw error;
    }
  }
  export async function getStageType(type:any) {
  
    try {
      const callParams = await getCallParams("GET");
      const response = await makeCall(
        
        urls.GETSTAGEDATA +
        `?type=${type}`,
        callParams);
      console.log(response,"reminderResponseData")
      return response;
    } catch (error) {
      throw error;
    }
  }

  export async function updateStage(body: any) {
    try {
      const callParams = await getCallParams("PUT", body);
      const response = await makeCall(urls.UPDATESTAGENEW, callParams);
      return response;
    } catch (error) {
      throw error;
    }
  }




  export async function deleteStage(id: string) {
    try {
      const callParams = await getCallParams("DELETE");
      const response = await makeCall(urls.DELETESTAGEDATA + id, callParams);
      return response;
    } catch (error) {
      throw error;
    }
  }
  



